import React from "react";
import Reports from "../components/boxes/Reports";
import Responsive from "../components/Responsive";
import StagesManager from "../components/StagesManager";
import ProfitLoss from "../components/boxes/reports/ProfitLoss";
import CashStatement from "../components/boxes/reports/CashStatement";
import BalanceSheet from "../components/boxes/reports/BalanceSheet";
import MovementEquity from "../components/boxes/reports/MovementEquity";
import SalesCustomer from "../components/boxes/reports/SalesCustomer";
import SalesItem from "../components/boxes/reports/SalesItem";
import SalesPerson from "../components/boxes/reports/SalesPerson";
import CustomerBalances from "../components/boxes/reports/CustomerBalances";
import ArAgingSummary from "../components/boxes/reports/ArAgingSummary";
import { translate } from "../utils/useful";



class AccountingReports extends React.Component {
    render() {
        return (
            <div style={{}}>
                {/* <Responsive width={this.props.width} display={'flex'} media={{ xs: '12' }}>
                    <Reports width={this.props.width} />
                </Responsive> */}
                <div style={{}}>
                    <div className="py-3 w-100" style={{ background: '#f5f5f5', }}>
                        <div className="flexc">
                            <div className="flexcb w-25 mld-2" style={{ border: '1px solid #dfdfdf', padding: '0 5px', borderRadius: 4 }}>
                                <div className="flexcc">
                                    <img style={{ marginRight: 3 }} src="/assets/icons/calendar.png" width={15} />
                                    <div>
                                        <p style={{ fontSize: 14 }}>{translate('This Month')}</p>
                                    </div>
                                </div>
                                <img src="/assets/icons/down.png" width={20} />
                            </div>&nbsp;
                            <div className="flexc">
                                <img src="/assets/icons/settings.png" width={15} />&nbsp;
                                <p style={{ color: '#408DFB', fontSize: 14 }}>{translate('Customize Report')}</p>
                            </div>
                        </div>
                        <div className="d-flex justify-content-end mt-2">
                            {/* <div className="w-15" style={{ border: '1px solid #dfdfdf', padding: '0px 5px', borderRadius: 4 }}>
                                <img style={{}} src="/assets/icons/share.png" width={18} />
                            </div> */}
                        </div>
                    </div>
                    <StagesManager ref={el => this.stageManager = el} height={'100%'} fast={true}  >
                        {/* <ProfitLoss stage={0} stageName={'profitloss'} initData={this.state.data} setData={this.setData}  /> */}
                        <ProfitLoss stage={0} stageName={'profitloss'} />
                        <CashStatement stage={1} stageName={'CashStatement'} />
                        <BalanceSheet stage={0} stageName={'balancesheet'} />
                        <MovementEquity stage={1} stageName={'movementequity'} />
                        <SalesCustomer stage={1} stageName={'salescustomer'} />
                        <SalesItem stage={1} stageName={'salesitem'} />
                        <SalesPerson stage={1} stageName={'salesperson'} />
                        <CustomerBalances stage={1} stageName={'customerbalances'} />
                        <ArAgingSummary stage={1} stageName={'aragingsummary'} />

                    </StagesManager>
                </div>
            </div>
        )
    }
}

export default AccountingReports;